
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import moment from "moment";

@Component({
  components: {
    WorkExperience: () => import("./WorkExperience.vue")
  }
})
export default class ExperienceUser extends Vue {
  @Prop(Object) user!: any;
  @Prop(Array) user_full!: any;
  @Prop(Boolean) user_edit!: boolean;
  @Prop(Function) deleteExperience!: any;
  @Prop(Function) editExp!: any;
  @Prop(Number) index!: any;
  flag_edit = false;
  new_exp = {};
  from_user = "";
  to_user = "";

  mounted() {
    this.format_date();
    this.new_exp = JSON.parse(JSON.stringify(this.user));
  }

  format_date() {
    this.from_user = moment(this.user.from)
      .format("MM")
      .toString()
      .concat("/")
      .concat(
        moment(this.user.from)
          .get("year")
          .toString()
      );
    this.to_user =
      !this.user.current_job && this.user.to
        ? moment(this.user.to)
            .format("MM")
            .toString()
            .concat("/")
            .concat(
              moment(this.user.to)
                .get("year")
                .toString()
            )
        : "Actualidad";
  }

  async edit_experience() {
    const _this: any = this;
    let elements = ["title", "nucleusTypeId", "company", "from"];
    if (!_this.new_exp.current_job && _this.new_exp.to) {
      elements.push("to");
    }
    await _this.$root.validateBeforeSubmit(elements, _this.new_exp);
    if (!(this as any).$root.error_bt.length) {
      // (this as any).$refs.loader_ref_exp.style.display = "flex";
      this.flag_edit = false;
      let element = {};
      (this as any).$emit("editExpUser", this.index, this.new_exp);
      let nu = this.$store.state.user.nucleus_user;
      let new_nu = [];
      for (let i = 0; i < this.user_full.length; i++) {
        element = {
          d_empresa:
            i === this.index
              ? _this.new_exp.company
              : _this.user_full[i].company,
          d_puesto:
            i === this.index ? _this.new_exp.title : _this.user_full[i].title,
          f_egreso: _this.user_full[i].current_job
            ? null
            : i === this.index
            ? _this.new_exp.to
            : _this.user_full[i].to,
          f_ingreso:
            i === this.index ? _this.new_exp.from : _this.user_full[i].from,
          o_tareas:
            i === this.index
              ? _this.new_exp.description
              : _this.user_full[i].description,
          oi_area_lab:
            (i === this.index
              ? (_this.new_exp.nucleusTypeId &&
                  _this.new_exp.nucleusTypeId.external_id) ||
                null
              : _this.user_full[i].nucleusTypeId &&
                _this.user_full[i].nucleusTypeId.external_id) || null
        };
        new_nu.push(element);
      }
      nu.expLaboralCV = new_nu;
      const response: any = await _this.$root._put(
        "userexperience/" + _this.user.id,
        {
          title: _this.new_exp.title,
          description: _this.new_exp.description,
          current_job: _this.new_exp.current_job,
          company: _this.new_exp.company,
          from: _this.new_exp.from,
          to: _this.new_exp.current_job ? null : _this.new_exp.to,
          nucleusTypeId:
            (_this.new_exp.nucleusTypeId && _this.new_exp.nucleusTypeId.id) ||
            null
        }
      );
      if (response) {
        // (this as any).$refs.loader_ref_exp.style.display = "none";
        (this as any).$emit("hideButton", true);
      }
      await _this.$root._put("user/" + _this.$store.state.user.id, {
        nucleus_user: nu
      });

      await (this as any).$root.reloadUser();
      this.$emit("newUserExp", this.$store.state.user);
      this.format_date();
    }
  }

  cancel_exp() {
    this.new_exp = JSON.parse(JSON.stringify(this.user));
    (this as any).$emit("editExpUser", this.index, this.user);
    (this as any).flag_edit = false;
    (this as any).$emit("hideButton", true);
  }
}
